// extracted by mini-css-extract-plugin
module.exports = {"flex":"pokedex_flex__CqX76","pagination":"pokedex_pagination__CIqRz"};